import React from 'react';
import {useTranslation} from 'react-i18next';
import Button from '../../../../../incase-domain/components/button/Button';

export type BooleanFilterLabelKey = 'common.all' | 'usersPage.archived' | 'usersPage.active' | 'presEditPage.yes' | 'presEditPage.no';

enum TriState {
    True,
    False,
    Both,
}

function toTriState(value: boolean | undefined): TriState {
    if (value === true) return TriState.True;
    if (value === false) return TriState.False;
    return TriState.Both;
}

export function BooleanFilterControl({
    value,
    onChange,
    labelBoth = 'common.all',
    labelTrue = 'presEditPage.yes',
    labelFalse = 'presEditPage.no',
}: {
    value: boolean | undefined;
    onChange: (value: boolean | undefined) => void;
    labelBoth?: BooleanFilterLabelKey;
    labelTrue?: BooleanFilterLabelKey;
    labelFalse?: BooleanFilterLabelKey;
}): JSX.Element {
    const {t} = useTranslation();

    const state = toTriState(value);

    return (
        <div className="c-genericTable__filter_boolean">
            <Button
                className="c-genericTable__filter_boolean_button"
                color="primary"
                variant={state === TriState.Both ? 'solid' : 'soft'}
                size="2xs"
                onClick={() => onChange(undefined)}
            >
                {t(labelBoth)}
            </Button>
            <Button
                className="c-genericTable__filter_boolean_button"
                color="primary"
                variant={state === TriState.True ? 'solid' : 'soft'}
                size="2xs"
                onClick={() => onChange(true)}
            >
                {t(labelTrue)}
            </Button>
            <Button
                className="c-genericTable__filter_boolean_button"
                color="primary"
                variant={state === TriState.False ? 'solid' : 'soft'}
                size="2xs"
                onClick={() => onChange(false)}
            >
                {t(labelFalse)}
            </Button>
        </div>
    );
}
